import { render, staticRenderFns } from "./script-settings-section.vue?vue&type=template&id=20f7caea&scoped=true&"
import script from "./script-settings-section.vue?vue&type=script&lang=js&"
export * from "./script-settings-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7caea",
  null
  
)

/* custom blocks */
import block0 from "./script-settings-section.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports